// extracted by mini-css-extract-plugin
export default {"body_404":"error_body_404__xL4q3","message":"error_message__FM806","load":"error_load__NpwEN"};